<template>

  <div>

    {{subscribedNotificationsNotDisplayed}}

  </div>


</template>

<script>
  import {Modal} from '@/common/components/index';
    export default {
      name: "OciNotifications",
      components: {
        Modal

      },
      data() {
        return{
          localStorageNotificationsClean:0,
          notifications:[],
          notificationsDisplayedIds:[],
          notificationsCount:0,
          connected: false,
          type: ['', 'info', 'success', 'warning', 'danger'],
          notifications: {
            topCenter: false
          },
          notificationMessage:'Test notification',
          notificationOptions: {
            verticalAlign: 'top',
            horizontalAlign:'right',
            timeout: 30000,
            icon: 'now-ui-icons ui-1_bell-53',
            type:'warning'

          }
               }

      },
      computed:{
        subscribedNotificationsNotDisplayed: function(){
          this.notifications=  this.$store.getters.subscribedNotificationsNotDisplayed;
          //   this.notificationsCount++
          // this.ociLog("Computed Fired")
          // this.ociLog(this.notifications.length)

        },
        subscribedNotifications: function(){
       //    this.notifications=  this.$store.getters.currentNotifications;
       // //   this.notificationsCount++
       //    this.ociLog("Computed Fired")
       //    this.ociLog(this.notifications.length)

        },
        notifyMessage:{
          get(){
            this.notifyVue(this.notificationMessage)
          },
         }
      },
      watch:{
        notifications: function(val) {
        // this.ociLog("Subscribed notifications triggered")
          let notificationArray = [];
          if (localStorage.getItem("notifications-displayed")===null ){
          // create empty array, to prepare to put displayed notifications in
            localStorage.setItem("notifications-displayed",JSON.stringify(notificationArray))
          }
          let displayedNotificationsArray = JSON.parse(localStorage.getItem("notifications-displayed"))
           for ( let i = 0; i<val.length;i++) {
            let match = false;
            for (let j = 0; j < displayedNotificationsArray.length; j++) {
              if (val[i].messageId ===displayedNotificationsArray[j].messageId){
                match = true;
              }
            }
            if(match===false){
              this.notifyVue(val[i].message)
              displayedNotificationsArray.push({messageId:val[i].messageId,endNotification:val[i].endNotification});

            }

          }

           //Add to local storage
           localStorage.setItem("notifications-displayed",JSON.stringify(displayedNotificationsArray))
         // this.ociLog("Display Array")
         // this.ociLog(this.notificationsDisplayedIds)
       }

      },

      methods: {
        cleanLocalDisplayedNotification(){
          let notifications = JSON.parse(localStorage.getItem('notifications-displayed'))
          if (notifications!==null){
            var secondsNow = Math.floor(new Date() / 1000);
            for(let i = 0; i<notifications.length;i++) {
              if (notifications[i].endNotification <secondsNow){
                notifications.splice(i,1)
              }
            }
            localStorage.setItem('notifications-displayed',JSON.stringify(notifications))
          }


        },
        notifyVue(message) {
          if (this.$store.getters.notificationHistoryDisplay ===false){

        // this.ociLog ("notifyVue  called ");

          this.$notify(
            {
              message: message,
              timeout: this.notificationOptions.timeout,
              icon: this.notificationOptions.icon,
              horizontalAlign: this.notificationOptions.horizontalAlign,
              verticalAlign: this.notificationOptions.verticalAlign,
              type: this.notificationOptions.type
            })
          }
        },

        // Sockets and Stomp methods


        connect() {

          this.socket = new this.$ociSockets.SockJS(this.$ociSockets.SOCKET_ENDPOINT_BASE);
          this.stompClient = this.$ociSockets.Stomp.over(this.socket);
          this.stompClient.connect(
            {},
            frame => {
              this.connected = true;
              this.ociLog(frame);
              this.stompClient.subscribe(this.$ociSockets.NOTIFICATION, tick => {
                this.addRecentNotification(JSON.parse(tick.body))
              });
            },
            error => {
              this.ociLog(error);
              this.connected = false;
            }
          );
        },
        disconnect() {
          if (this.stompClient) {
            this.stompClient.disconnect();
          }
          this.connected = false;
        },
        tickleConnection() {
          this.connected ? this.disconnect() : this.connect();
        },

        // Sockets and Stomp methods  -- End

        loadActiveNotifications(){
          this.$store.dispatch('loadActiveNotifications').then(() => {
          });
        },
        addRecentNotification(notification){
          this.$store.dispatch('addRecentNotification',notification).then(() => {
          });
        }

      },
      mounted(){
        //TODO -- turned off notifications socket connection, uncomment to resume socket connection
        if(process.env.VUE_APP_ENABLE_SOCKET_CONNECTION===true){
          this.connect();
          this.loadActiveNotifications();
          this.cleanLocalDisplayedNotification();
        }

      }
    }
</script>

<style >
  .card .alert {
    position: relative !important;
    width: 100%
  }

</style>
